<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-voice-wake-up`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M25 2c11.598 0 21 9.402 21 21s-9.402 21-21 21H6.1A2.1 2.1 0 014 41.9V23C4 11.402 13.402 2 25 2zm0 4C15.611 6 8 13.611 8 23v17h17c9.389 0 17-7.611 17-17S34.389 6 25 6zm.718 10c.446 0 .608.046.77.134.163.087.291.215.378.378.088.162.134.324.134.77v13.436c0 .446-.046.608-.134.77a.908.908 0 01-.378.378c-.162.088-.324.134-.77.134h-1.436c-.446 0-.608-.046-.77-.134a.908.908 0 01-.378-.378c-.088-.162-.134-.324-.134-.77V17.282c0-.446.046-.608.134-.77a.908.908 0 01.378-.378c.162-.088.324-.134.77-.134h1.436zm8 3c.446 0 .607.046.77.134.163.087.291.215.378.378.088.162.134.324.134.77v6.436c0 .446-.046.608-.134.77a.908.908 0 01-.378.378c-.163.088-.324.134-.77.134h-1.436c-.446 0-.607-.046-.77-.134a.908.908 0 01-.378-.378c-.088-.162-.134-.324-.134-.77v-6.436c0-.446.046-.608.134-.77a.908.908 0 01.378-.378c.162-.088.324-.134.77-.134h1.436zm-16 0c.446 0 .608.046.77.134.163.087.291.215.378.378.088.162.134.324.134.77v6.436c0 .446-.046.608-.134.77a.908.908 0 01-.378.378c-.162.088-.324.134-.77.134h-1.436c-.446 0-.607-.046-.77-.134a.908.908 0 01-.378-.378c-.088-.162-.134-.324-.134-.77v-6.436c0-.446.046-.608.134-.77a.908.908 0 01.378-.378c.162-.088.324-.134.77-.134h1.436z"/></svg>
</template>
<script>

export default {
  name: 'IconVoiceWakeUp',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
